import { render } from "./ArticlesView.vue?vue&type=template&id=0c21712c"
import script from "./ArticlesView.vue?vue&type=script&lang=js"
export * from "./ArticlesView.vue?vue&type=script&lang=js"

import "./ArticlesView.vue?vue&type=style&index=0&id=0c21712c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__